import type {MergeContext} from './types';

const TOKEN_RE = /\{([\w.]+)\}/g;

// File-name tokens are intentionally separate from the rich-text merge fields: they resolve to
// filename-safe fragments of the frozen document data, with no formatting or currency.
const FILE_NAME_TOKENS: Record<string, (ctx: MergeContext) => string> = {
	reference: ctx => ctx.data.projectIndicator || '',
	client: ctx => ctx.data.clientName || '',
	project: ctx => ctx.data.projectName || '',
	date: ctx => ctx.data.issuedDate || '',
};

/** Replaces {reference} / {client} / {project} / {date} tokens; unknown tokens become empty. */
export function resolveTemplateString(tpl: string, ctx: MergeContext): string {
	return tpl.replace(TOKEN_RE, (_, id: string) => {
		const token = FILE_NAME_TOKENS[id];
		if (!token) return '';
		try {
			return token(ctx);
		} catch {
			return '';
		}
	});
}

/** Resolves the download file name: tokens replaced, path-hostile characters stripped, .pdf enforced. */
export function resolveDownloadFileName(tpl: string, ctx: MergeContext): string {
	const resolved = resolveTemplateString(tpl, ctx)
		.replace(/[/\\:*?"<>|]/g, '-')
		.replace(/\s+/g, ' ')
		.trim();
	const base = resolved.replace(/\.pdf$/i, '') || 'quote';
	return `${base}.pdf`;
}
